import { render, staticRenderFns } from "./DetailComboSubModule.vue?vue&type=template&id=df0ffa74&scoped=true&"
import script from "./DetailComboSubModule.vue?vue&type=script&lang=js&"
export * from "./DetailComboSubModule.vue?vue&type=script&lang=js&"
import style0 from "./DetailComboSubModule.vue?vue&type=style&index=0&id=df0ffa74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0ffa74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VSimpleTable,VTextField,VTooltip})
